// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Ch","title":"Dh","nav":"Eh","flexCell":"Fh","facetLink":"Gh"};